import { render } from "./StatesSection.vue?vue&type=template&id=72f3183c&scoped=true"
import script from "./StatesSection.vue?vue&type=script&lang=js"
export * from "./StatesSection.vue?vue&type=script&lang=js"

import "./StatesSection.vue?vue&type=style&index=0&id=72f3183c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f3183c"]])

export default __exports__